import { Config } from 'config';

import { Xml } from '../util';
import { Point, Bounds, Frame } from '../geometry';

import { Figure } from './figure';
import { Shape, Polyregion } from './shape';
import { AbsoluteAnchor } from './anchor';

const _invalidate = function() { this.invalidate(); };

export const ProxyGroup = Figure.ProxyGroup = Figure.extend({ typeName: 'ProxyGroup',

  type: 'ProxyGroup',

  Properties: {
    link     : { type: 'string'   , def: null, dropDef:true, onChange: _invalidate },
    width    : { type: 'magnitude', def: null, dropDef:true },
    height   : { type: 'magnitude', def: null, dropDef:true },
    colorMap : { type: 'ColorMap' , def: null, dropDef:true, owned: true, onChange: _invalidate }
  },

  get isProxyGroup() { return true; },

  containsLinkedResources() {
    return true;
  },

  _primitive_computePreReferencePoint() {
    // console.log('_primitive_computePreReferencePoint');
    return new Point(0,0);
  },

  _primitive_computePreVectorBounds() {
    // console.log('_primitive_computePreVectorBounds');
    if( this._width && this._height ) {
      const w = this._width.toMM(), h = this._height.toMM();
      return new Bounds( -w/2, -h/2, w/2, h/2 );
    }
    else {
      return new Bounds( -50, -50, 50, 50 ) ;
    }
  },
  _primitive_computePreVectorBoundsAfter( transform ) {
    // console.log('_primitive_computePreVectorBoundsAfter');
    return Frame.fromBounds(this._primitive_computePreVectorBounds()).transformed(transform).bounds;
  },
  _primitive_computePreBounds() {
    // console.log('_primitive_computePreBounds');
    return this._primitive_computePreVectorBounds();
  },
  _primitive_computePreBoundsAfter( transform ) {
    // console.log('_primitive_computePreVectorBoundsAfter');
    return this._primitive_computePreVectorBoundsAfter(transform) ;
  },
  supportsLocalMetrics() {
    // We need to use the server to compute metrics of proxy groups
    // In order to compute the grouped figure bounds we need to use the
    // transform of the parent, so the only way we can work this out is
    // to use the parent group like a proxy group and let the server do
    // all the work
    return false;
  },
  needsCacheToRender() { return true; },
  _representationType() { return 'server'; },
  hasPreview() { return false; },
  otherColors( colors = [] ) {
    const colorMap = this._colorMap;
    if( colorMap ) {
      colorMap.getColors(colors);
    }
    return colors;
  },
  buildXml( parentNode ) {
    Xml.addObject(parentNode,this,'ProxyGroup');
  }
});


ProxyGroup.parseXml = function (node,bcFixes) {
  const proxyGroup = new ProxyGroup();

  Figure._baseParseXml.call(proxyGroup, node, ProxyGroup,bcFixes);

  return proxyGroup;
};

const ProxyGroupOutput = Shape.extend({ typeName: 'ProxyGroupOutput',
  needsCacheToRender() { return true; },
  _representationType() { return 'server'; },
});

Figure.createProxyGroupOutput = function(figure, preBounds, prePin) {
  if( Config.serverProxyGroupMetrics ) {
    // If we use server metrics, there is no need for local bounds computation
    return figure;
  }
  else {
    // We create a rectangular outline shape so the proxygroup works like a raster
    // wrt metrics. This makes the system faster because we can use local metrics.
    const polyregion = Polyregion.CreateRectangle({ bounds: preBounds });
    return new ProxyGroupOutput({
      polyregions: [polyregion],
      anchor: AbsoluteAnchor( prePin ),
      matrix22: figure._matrix22,
      pin: figure.pin
    });
  }
};



/** WEBPACK FOOTER **
 ** ./src/cdl/figure/proxy-group.js
 **/